import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'
import { pivotProductDecorator } from './decorator'
import generateStaticStrategy from './staticStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => {
  const staticStrategy = generateStaticStrategy()
  const decoratedStrategy = pivotProductDecorator(staticStrategy)
  return decoratedStrategy.composeDetailSearchFilter(filter, [], insights)
}

const generatePivotProductStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generatePivotProductStrategy
